/** 截图合成阶段可访问的二维输出画布上下文。 */
export interface ScreenshotCompositeContext {
  /** 已包含当前引擎画面的二维上下文。 */
  context: CanvasRenderingContext2D
  /** 输出截图宽度（物理像素）。 */
  width: number
  /** 输出截图高度（物理像素）。 */
  height: number
}

/** 在截图编码前向输出画布叠加宿主内容。 */
export type ScreenshotComposite = (value: ScreenshotCompositeContext) => void | Promise<void>

/** 引擎支持的截图 MIME 类型。 */
export type ScreenshotMimeType = 'image/jpeg' | 'image/png' | 'image/webp'

/** 将外部传入的 MIME 类型归一化为引擎支持的截图类型。 */
export function normalizeScreenshotMimeType(value?: string): ScreenshotMimeType {
  const normalized = value?.trim().toLowerCase()
  switch (normalized) {
    case undefined:
    case '':
    case 'image/jpg':
    case 'image/jpeg':
      return 'image/jpeg'
    case 'image/png':
      return 'image/png'
    case 'image/webp':
      return 'image/webp'
    default:
      throw new Error(`不支持的截图编码类型: ${value}`)
  }
}

/** 引擎截图参数。 */
export interface ScreenshotOptions {
  width?: number
  height?: number
  /** 输出 MIME 类型；支持 JPEG/JPG、PNG、WebP，默认 JPEG。 */
  mimeType?: ScreenshotMimeType
  quality?: number
  /**
   * 是否优先在独立 Worker 中完成图像编码。
   *
   * 浏览器不支持 Worker 编码时会自动回退到主线程。
   */
  workerEncoding?: boolean
  /** 截图编码 Worker 的静态资源基址，默认沿用 POTREE_BASE_URL。 */
  workerBaseUrl?: string
  /**
   * 可选的编码前合成回调。
   *
   * 引擎会把当前 WebGL 画布复制到二维输出画布，再调用此回调，
   * 最后只编码一次输出图像。
   */
  composite?: ScreenshotComposite
}
